export class EuiChip {
    id: string | number;
    euiInternalId: string;
    label: string;
    isRemovable = false;
    isOutline = false;
    isRounded = false;
    isDisabled = false;
    typeClass: ('primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger') = 'primary';
    sizeClass: ('euiSizeS' | 'euiSizeM' | 'euiSizeL' | 'euiSizeXL' | 'euiSize2XL') = 'euiSizeM';
    tooltip: EuiChipTooltip;
    iconClass?: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class EuiChipTooltip {
    tooltipMessage: string;
    color: ('none' | 'euiTooltipPrimary' | 'euiTooltipSecondary' | 'euiTooltipInfo' | 'euiTooltipSuccess' | 'euiTooltipWarning' |
        'euiTooltipDanger' | 'euiTooltipAccent') = 'none';
    position: ('above' | 'below' | 'left' | 'right' | 'before' | 'after') = 'above';
    contentAlignment: ('center' | 'left' | 'right' | 'justify') = 'center';
    rounded = false;
    arrows = false;
    delay = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
